/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import queryString from 'querystring';

import { ApiClient } from '../types/api/ApiClient';
import { DatasetCategory } from '../types/dataset/DatasetCategory';
import { getApiEndpoint } from '../utils/getApiEndpoint';
import { apiClientFactory } from '../utils/http-client/apiClientFactory';
import { axiosInstanceFactory } from '../utils/http-client/axiosInstanceFactory';
import { axiosJwtTokenInterceptor, axiosUnauthorizedInterceptor } from '../utils/http-client/axiosInterceptors';

class DatasetApiServiceClass {
  private api: ApiClient;

  constructor() {
    this.api = apiClientFactory(
      axiosInstanceFactory(
        { baseURL: getApiEndpoint() },
        [axiosJwtTokenInterceptor],
        [[undefined, axiosUnauthorizedInterceptor]],
      ),
    );
  }

  fetchDatasets = ({ language }: { language: string }) => {
    return this.api.get<DatasetCategory[]>(`/dataset?${queryString.encode({ language })}`);
  };
}

export const DatasetApiService = new DatasetApiServiceClass();
